import axios from 'axios'
import { config } from '../../static/campsite-ui-config'

let setAuthorizationToken = (token) => {
  console.log('Changed `X-Auth-Token` to:', token)
  if (token) {
    API.defaults.headers.common['X-Auth-Token'] = token
    // API.defaults.headers.common['x-auth-token'] = token
  } else {
    delete API.defaults.headers.common['X-Auth-Token']
    // delete API.defaults.headers.common['x-auth-token']
  }
}

// @TODO: Remove me, only for debugging
window.token = setAuthorizationToken

const API = axios.create({
  baseURL: `${config.baseURL}/api`,
})

export {
  setAuthorizationToken,
  API,
}



// WEBPACK FOOTER //
// ./src/api/axios.js